// src/lib/empty-module.ts
const empty = {};
export default empty;
export const readFileSync = () => null;
export const existsSync = () => false;
export const join = (...args: string[]) => args.join("/");
export const dirname = () => "";
export const normalize = (p: string) => p;
